<div class="form-group">
  <label for="prod-m">{{ 'form.customer'| translate }}</label>
  <angular2-multiselect #dropdown
    [data]="customerList"
    [(ngModel)]="customerSelected"
    [settings]="multiselectSettings[EMULTI_SELECT_SETTING.MULTIPLE_SEARCH]"
    (onSelect)="onCustomerSelect()"
    (onClose)="clearCustomerList()">
  </angular2-multiselect>
</div>